import cx from 'classnames';
import React from 'react';
import AnimateHeight from 'react-animate-height';
import { Accordion, Input } from 'semantic-ui-react';
import config from '@plone/volto/registry';
import { injectIntl } from 'react-intl';
import { accordionMessages as messages } from '../../../../../../../customization-messages';
import Icon from '@package/components/Icon';

// import styles from './edit.module.less';

const AccordionEdit = (props) => {
  const {
    children,
    handleTitleChange,
    handleTitleClick,
    uid,
    panel,
    data,
    index,
    intl,
  } = props;
  const [activeIndex, setActiveIndex] = React.useState([0]);
  const accordionConfig = config.blocks.blocksConfig.accordion;
  const isActive = activeIndex.includes(index);

  const handleClick = (e, itemProps) => {
    const { index } = itemProps;
    if (!data.exclusive) {
      const newIndex =
        activeIndex.indexOf(index) === -1
          ? [...activeIndex, index]
          : activeIndex.filter((item) => item !== index);

      setActiveIndex(newIndex);
    } else {
      const newIndex =
        activeIndex.indexOf(index) === -1
          ? [index]
          : activeIndex.filter((item) => item !== index);

      setActiveIndex(newIndex);
    }
  };

  React.useEffect(() => {
    return data.openOnStart ? setActiveIndex([0]) : setActiveIndex([]);
  }, [data.openOnStart]);

  const titleClass = cx('accordion-title', {
    'align-arrow-left': props?.data?.left_arrows,
    'align-arrow-right': !props?.data?.left_arrows,
    active: isActive,
    // group: data.groups,
    // 'text-interactive': !data.groups,
  });

  return (
    <Accordion
      className={accordionConfig?.defaults?.theme}
      {...accordionConfig.options}
    >
      <React.Fragment>
        <Accordion.Title
          as={data.title_size}
          active={isActive}
          index={index}
          onClick={handleClick}
          className={titleClass}
        >
          <Icon name={isActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />
          {!data.readOnlyTitles ? (
            <Input
              fluid
              className="input-accordion-title"
              transparent
              placeholder={intl.formatMessage(messages.EnterTitle)}
              value={panel?.title || ''}
              onClick={(e) => {
                handleTitleClick();
                e.stopPropagation();
              }}
              onChange={(e) => handleTitleChange(e, [uid, panel])}
            />
          ) : (
            <span>{panel?.title}</span>
          )}
        </Accordion.Title>
        <AnimateHeight
          animateOpacity
          duration={500}
          height={isActive ? 'auto' : 0}
        >
          <Accordion.Content active={isActive}>{children}</Accordion.Content>
        </AnimateHeight>
      </React.Fragment>
    </Accordion>
  );
};

export default injectIntl(AccordionEdit);
